import type { TSearchType } from "~ui/@core/stores/application/application-store.ts";

const placeholdersByType: Record<TSearchType, string> = {
  site: "Rechercher par site id",
  pilot: "Rechercher par l'id hardware du pilote",
  modulator: "Rechercher par l'id hardware du modulateur",
};

const types: Record<TSearchType, string> = {
  site: "Sites",
  pilot: "Pilotes",
  modulator: "Modulateurs",
};

export const COMMAND_MENU_FRENCH_LOCALE = {
  types,
  placeholders: placeholdersByType,
};
